import flatten from './flatten.js'
import { THP_CONVERSION, THP_CH_ENUM} from '../Tools/THP'
import { SDP1_CONVERSION, SDP1_CH_ENUM} from '../Tools/SDP1'
import { ST4C_CONVERSION, ST4C_CH_ENUM } from '../Tools/ST4C.js'
import { SA4C_CONVERSION, SA4C_CH_ENUM } from '../Tools/SA4C'
import { SSS1_CONVERSION, SSS1_CH_ENUM } from '../Tools/SSS1'
import { SCP1_CONVERSION, SCP1_CH_ENUM } from '../Tools/SCP1'
import { Aws,channelColors,graphDataLimit,monthLengths,sensorLive } from '../global/index.js'
import HelperService from '../Helpers/HelperService.js'
import { readString } from 'react-papaparse';
import _ from 'lodash'

export const ToolTypes = {
  THP: "STHP",
  SFLR: "SFLR",
  SHUT: "SHUT",
  ANALOG_4_CH: "SA4C",
  THERMO_4_CH: "ST4C",
  VOC: "SVOC",
  SWIM: "SSS1",
  CHEM: "SCP1",
  SDP: "SDP1"
}

export const getToolInfo = async ({token}) => {
  return fetch(`https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools?operation=tool_fw_status`, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    let response = {
      count: 0,
    }
    
    return response;
  })
  .catch((err) => {console.log("Error: ", err)});
};


export const getSiteDetails = async ({token, data_id, lts, uts}) => {
  return fetch(`https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/graph?operation=get_curData&data_id=${data_id}&lts=${lts}&uts=${uts}&attributes=ts,chiq1_ph,chiq1_orp,diiq1_dispenseLifeTime,diiq1_battVolt,caiq1_salt,chiq1_temp,caiq1_runTime,caiq1_onTime,tsiq1_salt,tsiq1_temp,lviq1_waterLevel,lviq1_totalFillTime,lviq1_battVolt`, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    let response = {
      count: 0,
      labels: [],
      timestamps: [],
      ph: [],
      orp: [],
      temp: [],
      salt: [],
      acid: [],
      runTime: [],
      onTime: [],
      dispenseBattery: [],
      fillTime: [],
      waterLevel: [],
      levelBattery: [],
    }

    data.Items?.forEach((item) => {
      response.count = response.count + 1
      // let formatted = formatTimestamp(item.ts)
      // response.labels.push(formatted)
      response.labels.push(new Date(item.ts * 1000))
      response.timestamps.push(item.ts)

      if(item.chiq1_ph) {
        response.ph.push(item.chiq1_ph)
      } else {
        response.ph.push(NaN)
      }

      if(item.chiq1_orp) {
        response.orp.push(item.chiq1_orp)
      } else {
        response.orp.push(NaN)
      }

      if(item.chiq1_temp) {
        response.temp.push(item.chiq1_temp)
      } else {
        if(item.tsiq1_temp) {
          response.temp.push(item.tsiq1_temp)
        } else {
          response.temp.push(NaN)
        }
      }

      if(item.caiq1_salt) {
        response.salt.push(item.caiq1_salt)
      } else {
        if(item.tsiq1_salt) {
          response.salt.push(item.tsiq1_salt)
        } else {
          response.salt.push(NaN)
        }
      }
      
      if(item.diiq1_dispenseLifeTime) {
        response.acid.push(item.diiq1_dispenseLifeTime)
      } else {
        response.acid.push(NaN)
      }

      if(item.diiq1_battVolt) {
        response.dispenseBattery.push(item.diiq1_battVolt)
      } else {
        response.dispenseBattery.push(NaN)
      }

      if(item.caiq1_runTime) {
        response.runTime.push(Math.round((item.caiq1_runTime / 3600) * 4) / 4)
      } else {
        response.runTime.push(NaN)
      }

      if(item.caiq1_onTime) {
        response.onTime.push(Math.round((item.caiq1_onTime / 3600) * 4) / 4)
      } else {
        response.onTime.push(NaN)
      }

      if(item.lviq1_waterLevel) {
        response.waterLevel.push(item.lviq1_waterLevel)
      } else {
        response.waterLevel.push(NaN)
      }

      if(item.lviq1_totalFillTime) {
        response.fillTime.push(item.lviq1_totalFillTime)
      } else {
        response.fillTime.push(NaN)
      }

      if(item.lviq1_battVolt) {
        response.levelBattery.push(item.lviq1_battVolt)
      } else {
        response.levelBattery.push(NaN)
      }
    })

    return response;
  })
  .catch((err) => {console.log("Error: ", err)});
};

export const addShare = async (token,mac,email_id) => {
  console.log('addShare token:',token)
  console.log('addShare mac:',mac,'email_id:',email_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "add_share",
      "mac": mac,
      "email_id":email_id,
    }),
  })
  .then(res => {
    console.log('addShare res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('addShare Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};
export const deleteShare = async (token,share_id) => {
  console.log('deleteShare token:',token)
  console.log('deleteShare share_id:',share_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_share",
      "share_id": share_id,
    }),
  })
  .then(res => {
    console.log('deleteShare res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('deleteShare Data:',data)
    return true;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const deleteRecipientShare = async (token,share_id) => {
  console.log('deleteRecipientShare token:',token)
  console.log('deleteRecipientShare share_id:',share_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_recipient_share",
      "share_id": share_id,
    }),
  })
  .then(res => {
    console.log('deleteRecipientShare res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('deleteRecipientShare Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const updateRecipient = async (token,share_id,recipientSettings) => {
  console.log('updateRecipient token:',token)
  console.log('updateRecipient share_id:',share_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_recipient_settings",
      "share_id": share_id,
      "recipientSettings": recipientSettings
    }),
  })
  .then(res => {
    console.log('updateRecipient res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('updateRecipient Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};
export const updateSender = async (token,share_id,senderSettings) => {
  console.log('updateSender token:',token)
  console.log('updateSender senderSettings:',senderSettings)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_sender_settings",
      "share_id": share_id,
      "senderSettings": senderSettings
    }),
  })
  .then(res => {
    console.log('updateSender res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('updateSender Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const checkRecipientEmail = async (token,email_id) => {
  console.log('checkRecipientEmail token:',token)
  console.log('checkRecipientEmail email_id:',email_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "check_recipient_email",
      "email_id": email_id
    }),
  })
  .then(res => {
    console.log('checkRecipientEmail res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('checkRecipientEmail Data:',data)
    if (HelperService.in200s(data.status)) {
      return data.message
    }else{
      return false
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const getSenderShares = async ({token}) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams?&operation=get_sender_shares', {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  }).then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  }).then(data => {
    let respJsonList = data.Items
    console.log('Shares Sent:',respJsonList)

    if (respJsonList && respJsonList.length > 0) {//shareMap.size
      return respJsonList//shareMap
    } else {
      console.log('No Shares found')
      return null
    }
  })
}

export const getRecipientShares = async ({token}) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams?&operation=get_recipient_shares', {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  }).then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  }).then(data => {
    let respJsonList = data.Items
    console.log('Share Recipients:',respJsonList)
    let mapShareData = (dataParse, mapObjec) => {
      if (_.isArray(dataParse)) {
        dataParse.forEach(item => {
          mapObjec.set(item.share_id, item)
        })
      }
    }
    let shareMap = new Map()
    mapShareData(respJsonList, shareMap)
    console.log('Share Map:',shareMap)

    if (shareMap.size > 0) {//shareMap.size
      return shareMap//shareMap
    } else {
      console.log('No Shares found')
      return null
    }
  })
}

export const getSharedTools = async ({token}) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams?&operation=get_user_shared_tools', {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  }).then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  }).then(data => {
    let respJsonList = data.Items
    console.log('Shared Tools:',respJsonList)


    if (respJsonList.length > 0) {
      return respJsonList
    } else {
      console.log('No Shares found')
      return null
    }
  })
}

export const getTools = async ({token}) => {
  let recipientShares = await getRecipientShares({token:token}).then(data => {
    console.log('data:',data)
    return data
  })
  console.log("recipientShares:",recipientShares)
  let response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools?&operation=get_tools&attributes=mac,sensor,toolType,settings,toolSettings,toolSystem,sessionStatus,data_id,data_id_createdAt,alerts,nextUpdateTS', {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    let response = {
      count: 0,
      items: {},
    }
    console.log(data)
    data.Items?.forEach((item) => {
      if(_.has(item, 'sensor') &&_.has(item, 'settings')){
        let convertedSensor = {}
        switch (item.toolType) {
          case ToolTypes.THP:
            convertedSensor = THP_CONVERSION(item)
            break;
          case ToolTypes.SDP:
            convertedSensor = SDP1_CONVERSION(item)
            break;
          case ToolTypes.ANALOG_4_CH:
            convertedSensor = SA4C_CONVERSION(item)
            break;
          case ToolTypes.THERMO_4_CH:
            convertedSensor = ST4C_CONVERSION(item)
            break;
          case ToolTypes.SWIM:
            convertedSensor = SSS1_CONVERSION(item)
            break;
          case ToolTypes.CHEM:
            convertedSensor = SCP1_CONVERSION(item)
            break;
          default:
            break;
        }
        item.convertedSensor = convertedSensor
      }
      // let pool = {
      //   poolName: item.cloudSettings?.poolSettings?.poolName ? item.cloudSettings?.poolSettings?.poolName : "No Name",
      //   poolSize: item.cloudSettings?.poolSettings?.poolSize ? item.cloudSettings?.poolSettings?.poolSize : null,
      //   mac: item.mac,
      //   data_id: item.data_id,
      //   user: item.user_id,
      //   lastUpdated: item.lastUpdatedAt,
      //   equipment: [], //THIS IS REDUNDANT WITH PRODUCTS ARRAY BUT WOULD REQUIRE REFACTORING
      //   products: [],
      //   sysFirmwareVersion: item.thingShadow?.reported?.system?.sysFwVer,
      // }

      // if(item.thingShadow?.reported?.devices) {
      //   Object.keys(item.thingShadow?.reported?.devices.discoveryManifest).forEach((deviceType) => {
      //     const pid = item.thingShadow?.reported?.devices.discoveryManifest[deviceType].pid
      //     pool.equipment.push(products[pid])

      //     const product = {
      //       uid: item.thingShadow?.reported?.devices.discoveryManifest[deviceType].uid,
      //       pid: pid,
      //       type: products[pid],
      //       status: item.thingShadow?.reported?.devices.discoveryManifest[deviceType].connectState,
      //       firmwareVersion: item.thingShadow?.reported?.devices.discoveryManifest[deviceType].ver,
      //     }
      //     pool.products.push(product)
      //   })

      //   Object.keys(item.thingShadow?.reported?.devices).forEach((deviceKey) => {
      //     let device = item.thingShadow?.reported?.devices[deviceKey]
      //     if(device.status?.hasOwnProperty("caiq1_salt")) {
      //       pool.salt = device.status?.caiq1_salt
      //     }

      //     if(device.status?.hasOwnProperty("chiq1_temp")) {
      //       pool.temp = device.status?.chiq1_temp
      //     }

      //     if(device.status?.hasOwnProperty("chiq1_orp")) {
      //       pool.orp = device.status?.chiq1_orp
      //     }

      //     if(device.status?.hasOwnProperty("chiq1_ph")) {
      //       pool.ph = device.status?.chiq1_ph
      //     }

      //     if(device.status?.hasOwnProperty("diiq1_acidVolume")) {
      //       pool.acidVolume = 100 - ((device.status?.diiq1_acidVolume / 56781.2) * 100)
      //     }

      //     if(device.status?.hasOwnProperty("diiq1_battVolt")) {
      //       pool.dispenseBattery = device.status?.diiq1_battVolt
      //     }

      //     if(device.status?.hasOwnProperty("lviq1_battVolt")) {
      //       pool.levelBattery = device.status?.lviq1_battVolt
      //     }

      //     if(device.status?.hasOwnProperty("lviq1_waterLevel") && device.status?.hasOwnProperty("lviq1_setPoint")) {
      //       pool.waterLevel = ((device.status?.lviq1_waterLevel / device.status?.lviq1_setPoint) * 100)
      //     }
      //   })
      // }

      response.count = response.count + 1
      response.items[item.mac] = item;
    })
    return response
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
  console.log('Current Response:',response)
  if(recipientShares){
    let sharedTools = await getSharedTools({token:token}).then(data => {
      return data
    })
    console.log("sharedTools:",sharedTools)
    sharedTools?.forEach((item) => {
      if(_.has(item, 'sensor') &&_.has(item, 'settings')){
        let convertedSensor = {}
        switch (item.toolType) {
          case ToolTypes.THP:
            convertedSensor = THP_CONVERSION(item)
            break;
          case ToolTypes.SDP:
            convertedSensor = SDP1_CONVERSION(item)
            break;
          case ToolTypes.ANALOG_4_CH:
            convertedSensor = SA4C_CONVERSION(item)
            break;
          case ToolTypes.THERMO_4_CH:
            convertedSensor = ST4C_CONVERSION(item)
            break;
          case ToolTypes.SWIM:
            convertedSensor = SSS1_CONVERSION(item)
            break;
          case ToolTypes.CHEM:
            convertedSensor = SCP1_CONVERSION(item)
            break;
          default:
            break;
        }
        item.convertedSensor = convertedSensor
      }
      response.count = response.count + 1
      response.items[item.share_id] = item;
    })
  }
  return response
};

function delay(delay) {
  return new Promise( res => setTimeout(res, delay) );
}

export const addGraphDataToStore =  (state, { graphData,scope,res }) => {
  console.log("ToolReducer- Func addGraphData",graphData)//,graphData)
  let resUpdate
  let resGraphData = _.cloneDeep(graphData)
  resGraphData.forEach(dataId=>{
    dataId = _.omit(dataId, ['totalRecordCount', 'updatedAt','rawData','convertedData','normalData','attributes','startOfData']);
  })
  switch (res) {
    case 'all':
      resUpdate={graphData:resGraphData}
      break
    case 'hour':
      resUpdate={graphDataHour:resGraphData}
      break
    case 'day':
      resUpdate={graphDataDay:resGraphData}
      break
    case 'month':
      resUpdate={graphDataMonth:resGraphData}
      break
    case '10':
      resUpdate={graphData10:resGraphData}
      break;
    case '100':
      resUpdate={graphData100:resGraphData}
      break;
    case '1000':
      resUpdate={graphData1000:resGraphData}
      break;
    default://null
      break
  }
  switch (scope) {
    case 'live':
      return {
        ...state,
        liveScope: graphData,
        ...resUpdate
      }
    case 'day':
      return {
        ...state,
        dayScope: graphData,
        ...resUpdate
      }
    case 'week':
      return {
        ...state,
        weekScope: graphData,
        ...resUpdate
      }
    case 'month':
      return {
        ...state,
        monthScope: graphData,
        ...resUpdate
      }
    case 'all':
      return {
        ...state,
        maxScope: graphData,
        ...resUpdate
      }
    case 'custom':
      return {
        ...state,
        customScope: graphData,
        ...resUpdate
      }
    default://null
      return {
        ...state,
        graphData: graphData,
        graphDataHour: graphData,
        graphDataDay: graphData,
        graphDataMonth: graphData,
        graphData10: graphData,
        graphData100: graphData,
        graphData1000: graphData,
        liveScope: graphData,
        dayScope: graphData,
        weekScope: graphData,
        monthScope: graphData,
        maxScope: graphData,
        customScope: graphData,
      }
  }
  
}

export const getLiveGraphData = async (token,dataID, share_id,attributes, lts, uts, res) => {
  console.log('PULLING GRAPH DATA')
  console.log('token:'+token+
              '\ndataID:'+dataID+
              '\nshare_id:'+share_id+
              '\nattributes:'+attributes+
              '\nlts:'+lts+
              '\nuts:'+uts+
              '\nres:'+res)
  let operation
  if(dataID){
    switch (res) {
      case 'all':
          operation = Aws.GET_LIVE_DATA_OPERATION
          break;
      case '10':
          operation = Aws.GET_LIVE_DATA_OPERATION_10
          break;
      case '100':
          operation = Aws.GET_LIVE_DATA_OPERATION_100
          break;
      case '1000':
          operation = Aws.GET_LIVE_DATA_OPERATION_1000
          break;
      default:
          break;
    }
  }else{
    switch (res) {
      case 'all':
          operation = Aws.GET_SHARED_DATA
          break;
      case '10':
          operation = Aws.GET_SHARED_DATA_10
          break;
      case '100':
          operation = Aws.GET_SHARED_DATA_100
          break;
      case '1000':
          operation = Aws.GET_SHARED_DATA_1000
          break;
      default:
          break;
    }
  }
  let uri 
  if(dataID){
      uri = Aws.URI.GRAPH_BASE + operation(dataID, attributes, lts, uts)
  }else{
      uri = Aws.URI.TEAM_BASE + operation(share_id, attributes, lts, uts)
  }
  
  let moreData = true
  let resp
  let respJsonItems = []
  let lastTS
  try {
    while(moreData){
      await fetch(uri, {
        method: 'GET',
        headers:{
            'Content-Type': 'application/json',
            'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
            'Authorization': await Aws.token(),
        },
      }).then(res => {
        if (!res.ok) {
          throw new Error(`HTTP error ${res.status}`);
        }
        return res.json()
      }).then(data => {
            console.info('Pulling..')
            console.log('Response:',data)
            respJsonItems = respJsonItems.concat(data.Items)
            console.log('respJsonItems:',respJsonItems)
            if(_.has(data,"LastEvaluatedKey")){
                console.info('More Data.')
                if(dataID){
                    lastTS = data.LastEvaluatedKey
                    lastTS = lastTS.ts
                    uri = Aws.URI.GRAPH_BASE + operation(dataID, attributes, lastTS+1, uts)
                }else{
                    lastTS = data.LastEvaluatedKey
                    lastTS = lastTS.ts
                    uri = Aws.URI.TEAM_BASE + operation(share_id, attributes, lastTS+1, uts)
                }
            }else{
                moreData = false
            }
        }) 
    }
    
    
    let dataEntry
    let convertedItems = []
    let attributeArray = attributes.split(',');
    console.log('attributeArray:',attributeArray)
    // attributeArray = attributeArray.data[0]
    console.info('Unmarshalling and Checking if number')
    flatten(respJsonItems)
    // attributeArray.forEach((attribute,i) => {
    //   let currentData = []
    //   if(i>0){
    //     convertedItems[i-1] = {'id':attribute,'color':channelColors[i-1],data:[]}
    //     respJsonItems.forEach((item, index) => {
    //       if(isNaN(Number(item[attribute]))){
    //         currentData[index] = {x:new Date(item.ts*1000),y:null}
    //       }else{
    //         currentData[index] = {x:new Date(item.ts*1000),y:item[attribute]}
    //       }
    //     })
    //     console.log('i:',i,'convertedItems[i-1]:',convertedItems[i-1])
    //     convertedItems[i-1]['data'] = currentData
    //   }
    // })


    respJsonItems.forEach((item, index) => {
      dataEntry = []
      attributeArray.forEach((attribute,i) => {
          try {
              dataEntry[i] = _.get(respJsonItems[index],attribute)
          
              if(isNaN(Number(dataEntry[i]))){
                  dataEntry[i] = null
              }else{
                  dataEntry[i] = Number(dataEntry[i])
              }
          } catch (error) {
              console.error(error)
              dataEntry[i] = null
          }               
      })
      // console.info('Setting dataEntry:',dataEntry)
      convertedItems[index] = dataEntry
    })
    console.info('Done converting items:',convertedItems)
    return convertedItems
    
} catch (err) {
    console.error('getLiveGraphData', "- Func - getLiveGraphData", err)
    return []
}
}

export const addGraphLiveData = async (state,setState,token,tool,scope,scopeAdjustment,customTime,recipient) => {
  console.log("ToolSaga- Func addGraphLiveData saga: \nArgs: ", state,setState,token,tool,scope,scopeAdjustment,customTime,recipient)
  try {
    // while(true){
        // let state //= await select();
        let toolState = state//.toolStore
        //FIGURE OUT WHAT RESOLUTION TO PULL FROM
        let now = new Date()
        let day = new Date()
        let aDay = 86400000
        let hours6 = 21600000
        let aWeek = 604800000
        day.setHours(0,0,0,0) 
        let date = day.getDate()
        let month = day.getMonth()+1
        let currMonth = (month + scopeAdjustment)%12
        if(currMonth<1) currMonth+=12
        let monthAdjustment = 0
        let index = 1
        while (index <= Math.abs(scopeAdjustment) && scopeAdjustment<0) {
          let tempMonth = (month - index)%12
          if(tempMonth<1) tempMonth+=12
          monthAdjustment += monthLengths[tempMonth]
          if(tempMonth == 2){//February
            //check for leap year
            if(HelperService.isLeapYear(new Date((day-monthAdjustment)).getFullYear())) monthAdjustment += aDay
          }
          index++
        }
        day = day.getTime()
        console.log('Day:',day,'scopeAdjustment:',scopeAdjustment)
        let monthStart = day - ((date-1) * aDay)
        let timeElapsed = sensorLive.getTimeElapsed(tool.data_id_createdAt) //tool.data_id_createdAt
        let timelimit6hr = Math.max(now-hours6,tool.data_id_createdAt*1000) //6hr tool.data_id_createdAt*1000
        let timelimit12hr = Math.max(now-(hours6*2),tool.data_id_createdAt*1000) //6hr  tool.data_id_createdAt*1000
        let timelimit24hr = Math.max(now-aDay,tool.data_id_createdAt*1000) //6hr  tool.data_id_createdAt*1000
        let timelimitDay = day+(aDay*scopeAdjustment)
        let timelimitWeek = day-(6*aDay)+(aWeek*scopeAdjustment)
        let timelimitMonth = monthStart-monthAdjustment
        let timelimitCustom = customTime?Math.max(customTime.start.getTime(),tool.data_id_createdAt*1000):null//custom  tool.data_id_createdAt*1000
        let rate = tool.settings.controls.sysUSBAcqPer * tool.settings.controls.sysUSBPostFreq
        let allPoints = Math.floor(timeElapsed/rate/1000)
        let points10 = Math.floor(allPoints/10)
        let points100 = Math.floor(allPoints/100)
        let points1000 = Math.floor(allPoints/1000)
        let currGraphDataMap
        let res
        let startOfData = false
        let liveLimit = timelimit6hr
        switch (scope) {
          case 'live':
            if(scopeAdjustment == -1){
              liveLimit = timelimit12hr
            }else if(scopeAdjustment == -2){
              liveLimit = timelimit24hr
            }
            res = 'all'
            break
          case 'all':
            if(points1000>=graphDataLimit){
              res = '1000'
            }else if(points100>=graphDataLimit){
              res = '100'
            }else if(points10>=graphDataLimit){
              res = '10'
            }else{
              res = 'all'
            }
            break
          case 'day':
            if(aDay/timeElapsed*points1000>=graphDataLimit){
              res = '1000'
            }else if(aDay/timeElapsed*points100>=graphDataLimit){
              res = '100'
            }else if(aDay/timeElapsed*points10>=graphDataLimit){
              res = '10'
            }else{
              res = 'all'
            }
            if(timelimitDay <= tool.data_id_createdAt*1000) startOfData = true
            break
          case 'week':
            if(aWeek/timeElapsed*points1000>=graphDataLimit){
              res = '1000'
            }else if(aWeek/timeElapsed*points100>=graphDataLimit){          
              res = '100'
            }else if(aWeek/timeElapsed*points10>=graphDataLimit){
              res = '10'
            }else{
              res = 'all'
            }
            if(timelimitWeek <= tool.data_id_createdAt*1000) startOfData = true
            break
          case 'month':
            if(monthLengths[currMonth]/timeElapsed*points1000>=graphDataLimit){
              res = '1000'
            }else if(monthLengths[currMonth]/timeElapsed*points100>=graphDataLimit){
              res = '100'
            }else if(monthLengths[currMonth]/timeElapsed*points10>=graphDataLimit){
              res = '10'
            }else{
              res = 'all'
            }
            if(timelimitMonth <= tool.data_id_createdAt*1000) startOfData = true
            break
          case 'custom':
            if(customTime && ((customTime.end.getTime()-timelimitCustom)/timeElapsed*points1000>=graphDataLimit)){
              res = '1000'
            }else if(customTime && ((customTime.end.getTime()-timelimitCustom)/timeElapsed*points100>=graphDataLimit)){
              res = '100'
            }else if(customTime && ((customTime.end.getTime()-timelimitCustom)/timeElapsed*points10>=graphDataLimit)){
              res = '10'
            }else if(customTime){
              res = 'all'
            }
            break
          default:
            break;
        }
        console.log('Set res:',res)

        let allData
        let tsIdx
        let lastTS
        let firstTS
        let tempData
        let attributeArray
        let apiAttributes
        let latestData
        
        switch (tool.toolType) {
          case ToolTypes.THP:
            attributeArray = await ["ts"].concat(...THP_CH_ENUM)
            break;
          case ToolTypes.SDP:
            attributeArray = await ["ts"].concat(...SDP1_CH_ENUM)
            break;
          case ToolTypes.ANALOG_4_CH:
            //TODO
            attributeArray = await ["ts"].concat(...SA4C_CH_ENUM)
            break;
          case ToolTypes.THERMO_4_CH:
            attributeArray = await ["ts"].concat(...ST4C_CH_ENUM)
            break;
          case ToolTypes.SWIM:
            attributeArray = await ["ts"].concat(...SSS1_CH_ENUM)
            break;
          case ToolTypes.CHEM:
            attributeArray = await ["ts"].concat(...SCP1_CH_ENUM)
          default:
            break;
        }
        console.log('Set attributeArray:',attributeArray)
        apiAttributes = await attributeArray.join()
        tsIdx = 0
        switch (res) {
          case 'all':
            currGraphDataMap = await _.cloneDeep(toolState.graphData)  
            break;
          case '10':
            currGraphDataMap = await _.cloneDeep(toolState.graphData10)  
            break;
          case '100':
            currGraphDataMap = await _.cloneDeep(toolState.graphData100)  
            break;
          case '1000':
            currGraphDataMap = await _.cloneDeep(toolState.graphData1000)  
            break;
          default:
            break;
        }
        console.log('Set currGraphDataMap:',currGraphDataMap)
        if(tool.data_id){
          latestData = await currGraphDataMap.get(tool.data_id)
        }else{
          latestData = await currGraphDataMap.get(tool.share_id)
        }
        if(latestData!= undefined && !_.isEmpty(latestData)){
          allData = latestData.data
        } else{
          allData = []
        }
        while(true){//While not enough data pulled (breaks if in highest res or enough data pulled)
          lastTS = allData.length>0?allData[allData.length-1][tsIdx]:tool.data_id_createdAt//Get last timestamp from data
          firstTS = allData.length>0?allData[0][tsIdx]:tool.data_id_createdAt//Get first timestamp from data
          let lts
          let uts
          if(scope == 'live'){
            if(lastTS == tool.data_id_createdAt){//First data pull
              lts = Math.floor((timelimit24hr)/1000)
            }else{
              lts = lastTS+1
            }
            uts = HelperService.getEpoch(new Date())
          }else if(scope == 'day'){
            if(lastTS == tool.data_id_createdAt || firstTS > Math.floor((timelimitDay)/1000)){//First data pull or need to pull earlier data
              lts = Math.floor((timelimitDay)/1000)
              uts = lastTS == tool.data_id_createdAt?HelperService.getEpoch(new Date()):firstTS-1
            }else if(scopeAdjustment == 0){//Today
              lts = lastTS + 1
              uts = HelperService.getEpoch(new Date())
            }else{
              //No need to pull
              lts = null
              uts = null
            }
          }else if(scope == 'week'){
            if(lastTS == tool.data_id_createdAt || firstTS > Math.floor((timelimitWeek)/1000)){//First data pull or need to pull earlier data
              lts = Math.floor((timelimitWeek)/1000)
              uts = lastTS == tool.data_id_createdAt?HelperService.getEpoch(new Date()):firstTS-1
            }else if(scopeAdjustment == 0){//This week
              lts = lastTS + 1
              uts = HelperService.getEpoch(new Date())
            }else{
              //No need to pull
              lts = null
              uts = null
            }
          }else if(scope == 'month'){
            if(lastTS == tool.data_id_createdAt || firstTS > Math.floor((timelimitMonth)/1000)){//First data pull or need to pull earlier data
              lts = Math.floor((timelimitMonth)/1000)
              uts = lastTS == tool.data_id_createdAt?HelperService.getEpoch(new Date()):firstTS-1
            }else if(scopeAdjustment == 0){//This week
              lts = lastTS + 1
              uts = HelperService.getEpoch(new Date())
            }else{
              //No need to pull
              lts = null
              uts = null
            }
          }else if(scope == 'all'){
            if(lastTS == tool.data_id_createdAt || firstTS > tool.data_id_createdAt){//First data pull or need to pull earlier data
              lts = tool.data_id_createdAt
              uts = lastTS == tool.data_id_createdAt?HelperService.getEpoch(new Date()):firstTS-1
            }else{
              lts = lastTS + 1
              uts = HelperService.getEpoch(new Date())
            }
          }else if(scope == 'custom' && customTime){
            if(lastTS == tool.data_id_createdAt || firstTS > Math.floor((timelimitCustom)/1000)){//First data pull or need to pull earlier data
              lts = Math.floor((timelimitCustom)/1000)
              uts = lastTS == tool.data_id_createdAt?customTime.end.getTime():firstTS-1
            }else if(lastTS<customTime.end.getTime()){//need to pull later data
              lts = lastTS + 1
              uts = customTime.end.getTime()
            }else{
              //No need to pull
              lts = null
              uts = null
            }
          }else{
            lts = null
            uts = null
          }
          if(lts && uts){
            console.info("PULLING NEW DATA",token,tool.data_id,tool.share_id,apiAttributes,lts,uts,res)
            tempData = await getLiveGraphData(token,tool.data_id,tool.share_id,apiAttributes,lts,uts,res)
            // tempData = await SessionService.getLiveGraphData(tool.data_id,tool.share_id,apiAttributes,lts,uts,res)
            console.info("DATA PULLED:",tempData)
            console.info("DATA PULLED. LENGTH:",tempData.length)
            //Filter duplicate timestamps
            console.info("FILTERING NEW DATA")
            // tempData = await tempData.filter((data,index) => tempData.findIndex((a)=>a[tsIdx]==data[tsIdx]) == index)
            console.info("NEW DATA FILTERED. LENGTH:",tempData.length)
            //Add to all data
            if(tempData.length>0){
              if(lastTS==tool.data_id_createdAt){
                console.log('Pulled all data')
                allData = tempData
              }else if(lts>lastTS){//add new data to end
                console.log('Adding new data to end')
                // for(let i = 0; i < tempData.length; i++){
                //   tempData.forEach((attribute,index) => {
                //     allData[index].data.push(attribute.data[i])
                //   });
                // }
                for(let i = 0; i < tempData.length; i++){
                allData.push(tempData[i]);
                }
              }else{//add new data to start
                console.log('Adding new data to start')
                // for(let i = 0; i < allData.length; i++){
                //   allData.forEach((attribute,index) => {
                //     tempData[index].data.push(attribute.data[i])
                //   });
                // }
                // allData = tempData
                for(let i = 0; i < allData.length; i++){
                    tempData.push(allData[i]);
                }
                allData = tempData
              }
            }
          }
          console.log('All Data:',allData)
          switch (scope) {
            case 'live':
              console.log('Filtering for live')
              // tempData.forEach(async (attribute,index) => {
              //   tempData[index].data = await attribute.data.filter(data => Math.floor(data.x.getTime() / 1000) >= Math.floor((liveLimit)/1000)); //LAST 6 HOURS
              // });
              tempData = await allData.filter(data => data[tsIdx] >= Math.floor((liveLimit)/1000));    //LAST 6 HOURS
              break
            case 'all':
              console.log('Filtering for all')
            // case 'custom':
              tempData = allData
              break
            case 'day':
              console.log('Filtering for day timelimitDay:',timelimitDay)
              // tempData.forEach(async (attribute,index) => {
              //   tempData[index].data = await attribute.data.filter(data => Math.floor(data.x.getTime() / 1000) >= Math.floor((timelimitDay)/1000) && Math.floor(data.x.getTime() / 1000)<=Math.floor((timelimitDay+aDay)/1000));    //LAST DAY
              // });
              tempData = await allData.filter(data => data[tsIdx] >= Math.floor((timelimitDay)/1000) && data[tsIdx]<=Math.floor((timelimitDay+aDay)/1000));    //LAST DAY
              break
            case 'week':
              console.log('Filtering for week')
              // tempData.forEach(async (attribute,index) => {
              //   tempData[index].data = await attribute.data.filter(data => Math.floor(data.x.getTime() / 1000) >= Math.floor((timelimitWeek)/1000) && Math.floor(data.x.getTime() / 1000)<=Math.floor((timelimitWeek+aWeek)/1000));    //LAST WEEK
              // });
              tempData = await allData.filter(data => data[tsIdx] >= Math.floor((timelimitWeek)/1000) && data[tsIdx]<=Math.floor((timelimitWeek+aWeek)/1000));    //LAST WEEK
              break
            case 'month':
              console.log('Filtering for month')
              // tempData.forEach(async (attribute,index) => {
              //   tempData[index].data = await attribute.data.filter(data => Math.floor(data.x.getTime() / 1000) >= Math.floor((timelimitMonth)/1000) && Math.floor(data.x.getTime() / 1000)<=Math.floor((timelimitMonth+monthLengths[currMonth])/1000));    //LAST MONTH
              // });
              tempData = await allData.filter(data => data[tsIdx] >= Math.floor((timelimitMonth)/1000) && data[tsIdx]<=Math.floor((timelimitMonth+monthLengths[currMonth])/1000));    //LAST MONTH
              break
            case 'custom':
              if(customTime){
                console.log('Filtering for custom')
                // tempData.forEach(async (attribute,index) => {
                //   tempData[index].data = await attribute.data.filter(data => Math.floor(data.x.getTime() / 1000) >= Math.floor((timelimitCustom)/1000) && Math.floor(data.x.getTime() / 1000)<=customTime.end.getTime()/1000);    //CUSTOM
                // });
                tempData = await allData.filter(data => data[tsIdx] >= Math.floor((timelimitCustom)/1000) && data[tsIdx]<=customTime.end.getTime()/1000);    //CUSTOM
              }
              break
            default:
              break;
          }
          console.log('tempData after filtering:',tempData)
          let limitedData = await HelperService.limitData(tempData)
          let convertedData = await HelperService.convertData(tool,limitedData,attributeArray)
          let maxMinData = await HelperService.maxMin(convertedData,tsIdx)
          let normalizedData = await HelperService.normalizeData(tool.toolType,recipient?recipient.recipientSettings:tool.settings,convertedData,tsIdx,attributeArray,maxMinData[0],maxMinData[1],null,recipient?tool.settings:null)
          console.log("limitedData:",limitedData,'convertedData:',convertedData,'maxMinData:',maxMinData,'normalizedData:',normalizedData)
          await currGraphDataMap.set(_.has(tool,'data_id')?tool.data_id:tool.share_id, {"startOfData":startOfData,"data_id_createdAt":tool.data_id_createdAt,"totalRecordCount":allData.length,"updatedAt":HelperService.getEpoch(new Date()),"data":allData, "rawData":limitedData, "convertedData": convertedData, "normalData":normalizedData, "maxData":maxMinData[0],"minData":maxMinData[1] ,"attributes":attributeArray}) //"maxData":maxMinData[0],"minData":maxMinData[1]
          

          if(res != 'all' && (_.isEmpty(tempData) || tempData.length<graphDataLimit)){//Too few points because expected was off.. pull next highest res instead
            console.log("EXPECTED DATA COUNT WAS OFF. PULLING DATA AGAIN")
            switch (res) {
              case '1000':
                if(tempData.length*10>=graphDataLimit){
                  res = '100'
                }else if(tempData.length*100>=graphDataLimit){
                  res = '10'
                }else{
                  res = 'all'
                }
                break;
              case '100':
                if(tempData.length*10>=graphDataLimit){
                  res = '10'
                }else{
                  res = 'all'
                }
                break;
              default:
                res = 'all'
                break;
            }
            switch (res) {
              case 'all':
                currGraphDataMap = await _.cloneDeep(toolState.graphData)  
                break;
              case 'hour':
                currGraphDataMap = await _.cloneDeep(toolState.graphDataHour)  
                break;
              case 'day':
                currGraphDataMap = await _.cloneDeep(toolState.graphDataDay)  
                break;
              case '10':
                currGraphDataMap = await _.cloneDeep(toolState.graphData10)  
                break;
              case '100':
                currGraphDataMap = await _.cloneDeep(toolState.graphData100)  
                break;
              case '1000':
                currGraphDataMap = await _.cloneDeep(toolState.graphData1000)  
                break;
              default:
                break;
            }
            if(tool.data_id){
              latestData = await currGraphDataMap.get(tool.data_id)
            }else{
              latestData = await currGraphDataMap.get(tool.share_id)
            }
            if(latestData!= undefined && !_.isEmpty(latestData)){
            allData = latestData.data
            } else{
            allData = []
            }
          }else{
            console.info("BREAKING OUT OF LOOP")
            break
          }
        }  
        let newValue = await addGraphDataToStore(state, {graphData:currGraphDataMap,scope:scope,res:res})
        console.log('addGraphLiveData Updating AllSites to ',newValue)
        if(!_.isEqual(newValue,state)) setState(newValue)//ADD DATA TO STORE  
        // await delay(tool.settings.controls.sysUSBAcqPer>10?tool.settings.controls.sysUSBAcqPer*1000:10000)
    // }
  } catch (error){
    console.error(error.message)
  } 
  // finally {
  //   if (await cancelled()) console.info("addGraphLiveData cancelled")
  // }
}
export const getUser = async (token) => {
  console.log('getUser token:',token)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user?&operation=get_user&attributes=settings,sessionFolders', {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    console.log('getUser res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('getUser Data:',data)
    return data.Items[0];
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const updateUser = async (token,settings) => {
  console.log('Update User token:',token)
  console.log('Update User settings:',settings)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_user",
      "settings": settings
    }),
  })
  .then(res => {
    console.log('updateUser res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('updateUser Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const getUserDeleteToken = async (token,password) => {
  console.log('getUserDeleteToken token:',token)
  console.log('getUserDeleteToken password:',password)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "get_user_deleteToken",
      "password": password
    }),
  })
  .then(res => {
    console.log('getUserDeleteToken res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('getUserDeleteToken Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const deleteUser = async (token,deleteToken) => {
  console.log('deleteUser token:',token)
  console.log('deleteUser deleteToken:',deleteToken)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_user",
      "deleteToken": deleteToken
    }),
  })
  .then(res => {
    console.log('deleteUser res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('deleteUser Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

export const checkSubscriptionLevel = async (token) => {
  console.log('checkSubscriptionLevel token:',token)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "check_subscription",
    }),
  })
  .then(res => {
    console.log('checkSubscriptionLevel res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    // flatten(data)
    console.log('checkSubscriptionLevel Data:',data.data)
    return data.data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return null
  });
};

// export const getAlerts = () => {
//   return fetch("https://dummyjson.com/comments").then((res) => res.json()).catch((err) => {console.log("Error: ", err)});
// };

export const updateToolSettings = async (tool, toolSettings) => {
  console.log('updateToolSettings:',tool, toolSettings)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "update_tool",
        "mac": tool.mac,
        "settings": toolSettings
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "update_shared_tool",
        "share_id": tool.share_id,
        "settings": toolSettings
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const identifyTool = async (token, tool) => {
  console.log('identifyTool:',token, tool)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "identify_tool",
        "mac": tool.mac
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "identify_shared_tool",
        "share_id": tool.share_id
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const clearData = async (token, tool) => {
  console.log('clearData:',token, tool)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_tool",
        "mac": tool.mac
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_shared_tool",
        "share_id": tool.share_id
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const getToolByMac = async (tool, attributes) => {
  console.log('getToolByMac tool:',tool, ' attributes:',attributes)
  let uri 
  if(_.has(tool,'mac')){
    uri = `https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools?&operation=get_mac&mac=${tool.mac}&attributes=${attributes}`
  }else{
    uri = `https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams?&operation=get_shared_tool&share_id=${tool.share_id}`
  } 
  console.log('uri:',uri)
  return fetch(uri, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    console.log('getToolByMac res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    // 
    console.log('getToolByMac Data:',data)
    if(Array.isArray(data.Items)){
      flatten(data)
      return data.Items[0]
    } 
    return data.Items
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { error: err }
  });
}

export const getToolSettings = async (tool) => {
  let toolData = await getToolByMac(tool,"mac,settings,toolSystem,toolSettings,nextUpdateTS")
  console.log('getToolSettings toolData:',toolData)
  return toolData
}
export const getAlerts = async (tool) => {
  let toolAlerts = []
  let toolData = await getToolByMac(tool,"mac,alerts")
  console.log('getAlerts toolData:',toolData)
  if(_.has(toolData,'error')){
    return { error: toolData.error }
  }else{
    if (_.has(toolData,'alerts')) {
      toolAlerts = toolData.alerts
    } else {
      //No Alerts
    }
    return toolAlerts
  }  
}

export const fwStatus = async (token,mac) => {
  console.log('fwStatus token: ',token, ' mac: ',mac)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "tool_fw_status",
      "mac":mac,
    }),
  })
  .then(res => {
    console.log('fwStatus res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('fwStatus Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const fwUpdate = async (token,mac,version) => {
  console.log('fwUpdate token: ',token, ' mac: ',mac, 'version:',version)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_tool_firmware",
      "mac":mac,
      "updateVersion":version
    }),
  })
  .then(res => {
    console.log('fwUpdate res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('fwUpdate Data:',data)
    return data;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const removeTool = async (token,mac) => {
  console.log('removeTool token: ',token, ' mac: ',mac)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_tool",
      "mac":mac,
    }),
  })
  .then(res => {
    console.log('removeTool res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    flatten(data)
    console.log('removeTool Data:',data)
    return true;
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

let unmarshallMessageData = (dataParse, mapObjec) => {
  if (_.isArray(dataParse)) {
      dataParse.forEach(item => {
          mapObjec.set(item.message_id, item)
      })
  }
}
let unmarshallSessionData = (dataParse, mapObjec) => {
  if (_.isArray(dataParse)) {
      dataParse.forEach(item => {
          mapObjec.set(item.sessionID, item)
      })
  }
}
export const getMessages = async (attributes = null) => {
  return fetch(`https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages?&operation=get_user_messages&attributes=${attributes}`, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then((data) => {
    flatten(data)
    console.log("getMessages response:",data)
      let respJsonItems =  data.Items

      let respMap = new Map()

      //This will be used unMarshal the data from dynamoDBr
      unmarshallMessageData(respJsonItems, respMap)

      console.log("- Func - getMessages: ", respMap)


      if (respMap.size > 0) {
          return respMap
      } else {
          console.log('- Func getMessages: No Messages')
          return null
      }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors:err }
  });
};

export const deleteMessages = async (message_ids) => {
  console.log('deleteMessages message_ids: ',message_ids)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_multi_messages",
      "message_ids":message_ids,
    }),
  })
  .then(res => {
    console.log('deleteMessages res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('deleteMessages Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const deleteUserMessages = async () => {
  console.log('deleteUserMessages')
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_user_messages",
    }),
  })
  .then(res => {
    console.log('deleteUserMessages res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('deleteUserMessages Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const markAllRead = async () => {
  console.log('markAllRead')
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "markRead_user_messages",
    }),
  })
  .then(res => {
    console.log('markAllRead res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('markAllRead Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const updateMessage = async (message_id,settings) => {
  console.log('updateMessage message_id: ',message_id,'settings:',settings)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/messages', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_message",
      "message_id":message_id,
      "settings":settings,
    }),
  })
  .then(res => {
    console.log('updateMessage res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('updateMessage Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const getAllSessions = async (attributes = '') => {
  return fetch(`https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session?&operation=get_user_sessions&attributes=${attributes}`, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then((data) => {
    flatten(data)
    console.log("getAllSessions response:",data)
      let respJsonItems =  data.Items

      let respMap = new Map()

      //This will be used unMarshal the data from dynamoDBr
      unmarshallSessionData(respJsonItems, respMap)

      console.log("- Func - getAllSessions: ", respMap)


      return respMap
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors:err }
  });
};

export const saveSession = async (session) => {
  console.log('saveSession:',session)
  let response
  if(_.has(session.target,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "save_session",
        "target": session.target,
        "settings": session.settings
      }),
    })
    .then(res => {
      console.log('saveSession res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      console.log('saveSession data:',data)
      return true;
    })
    .catch((err) => {
      console.log("saveSession Error: ", err)
      return { errors:err }
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "save_shared_session",
        "target": session.target,
        "settings": session.settings
      }),
    })
    .then(res => {
      console.log('saveSession res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      console.log('saveSession data:',data)
      return true;
    })
    .catch((err) => {
      console.log("saveSession Error: ", err)
      return { errors:err }
    });
  }
  console.log('Response:', response)
  return response
}

export const exportFile = async (session) => {
  console.log('exportFile:',session)
  let response
  if(_.has(session.target,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "export_file",
        "target": session.target,
        "settings": session.settings,
        "fileType": session.fileType
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return { errors:err }
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "export_shared_file",
        "target": session.target,
        "settings": session.settings,
        "fileType": session.fileType
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return { errors:err }
    });
  }
  console.log('Response:', response)
  return response
}

export const deleteSessions = async (session_ids) => {
  console.log('deleteSessions session_ids: ',session_ids)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_multi_sessions",
      "session_ids":session_ids,
    }),
  })
  .then(res => {
    console.log('deleteSessions res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('deleteSessions Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const updateSession = async (session_id,settings) => {
  settings = settings.settings
  console.log('updateSession session_id: ',session_id, ' settings:',settings)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "update_session",
      "sessionID":session_id,
      "settings":settings,
    }),
  })
  .then(res => {
    console.log('updateSession res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('updateSession Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const sendSessions = async (sessionIDs,email_id) => {
  console.log('sendSessions sessionIDs: ',sessionIDs, ' email_id:',email_id)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "send_sessions",
      "sessionIDs":sessionIDs,
      "email_id":email_id,
    }),
  })
  .then(res => {
    console.log('sendSessions res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('sendSessions Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const moveSessions = async (sessions) => {
  console.log('moveSessions sessions: ',sessions)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "move_multi_sessions",
      "sessions":sessions,
    }),
  })
  .then(res => {
    console.log('moveSessions res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('moveSessions Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const getFile = async (sessionID, file) => {
  console.log('getFile session:',sessionID,'file:',file,'token:',await Aws.token())
  return fetch(`https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/storage?sessionID=${sessionID}&file=${file}`, {
    method: 'GET',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
  }).then(res => {
    console.log('getFile res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.text()
  }).then(data => {
    console.log('getFile data:',data)
    if (data) {
      return data
    } else {
      return null
    }
  }).catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
}

export const newSheet = async (settings,name,token) => {
  console.log('newSheet settings: ',settings,'name:',name)
  
  let driveUri = 'https://www.googleapis.com/drive/v3/files'
  let sheetUri = 'https://sheets.googleapis.com/v4/spreadsheets/'
  let resp
  // let token = ""
  let sheetID = ""
  
  const config = {
    issuer: 'https://accounts.google.com',
    clientId: '939028926181-cjv3ea7mikhe75nj45a4bq15cm2scv8c.apps.googleusercontent.com',
    redirectUrl: 'com.stratusapp:/Dashboard',
    scopes: ['openid', 'profile','https://www.googleapis.com/auth/drive.file',]
  };
  await fetch(driveUri, {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify({ 
      "mimeType": "application/vnd.google-apps.spreadsheet",
      "name": name
    }),
  })
  .then(res => {
    console.log('newSheet create res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json();
  })
  .then(data => {
    console.log('newSheet create Data:',data)
    if(data.id) sheetID = data.id
  })
  .catch((err) => {
    console.log("Error: ", err)
  });
  let data
  if(_.has(settings.target,'mac')){
    console.log('has mac')
    data = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "export_file",
        "target": settings.target,
        "settings": settings,
        "fileType": settings.fileType
      }),
    })
    .then(res => {
      console.log('newSheet getData res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      console.log('newSheet getData data:',data)
      return data.data;
    })
    .catch((err) => {
      console.log("newSheet getData Error: ", err)
      return { errors:err }
    });
  }else{
    console.log('no mac')
    data = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "export_shared_file",
        "target": settings.target,
        "settings": settings,
        "fileType": settings.fileType
      }),
    })
    .then(res => {
      console.log('newSheet getData res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      console.log('newSheet getData data:',data)
      return data.data;
    })
    .catch((err) => {
      console.log("newSheet getData Error: ", err)
      return { errors:err }
    });
  }
  let myURI = sheetUri+sheetID+"/values/Sheet1?valueInputOption=RAW"
  resp = await fetch(myURI, {
    method: 'PUT',
    headers:{
        'Content-Type': 'application/json',
        'Authorization': token,
    },
    body: JSON.stringify({ 
      "range": "Sheet1",
      "values": data
    }),
  })
  .then(res => {
    console.log('newSheet update res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json();
  })
  .then(data => {
    console.log('newSheet update Data:',data)
    if(data){
      window.open("https://docs.google.com/spreadsheets/d/"+sheetID+"/edit#gid=0")
      return true
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
  });
};

export const addFolder = async (sessionFolder) => {
  console.log('addFolder sessionFolder: ',sessionFolder)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "add_sessionFolder",
      "sessionFolder":sessionFolder,
    }),
  })
  .then(res => {
    console.log('addFolder res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('addFolder Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const deleteFolders = async (sessionFolders) => {
  console.log('deleteFolders sessionFolders: ',sessionFolders)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_multi_sessionFolders",
      "sessionFolders":sessionFolders,
    }),
  })
  .then(res => {
    console.log('deleteFolders res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('deleteFolders Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const renameFolder = async (sessionFolder, targetName) => {
  console.log('renameFolder sessionFolder: ',sessionFolder," targetName:",targetName)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/session', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "rename_sessionFolder",
      "sessionFolder":sessionFolder,
      "targetName":targetName,
    }),
  })
  .then(res => {
    console.log('renameFolder res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('renameFolder Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const addGraphData = async (state, setState, sessionID) =>{
  console.log("addGraphData sessionID:",sessionID)
  let session = state.sessions.get(sessionID)
  console.log("Session:",session)
  let currState = _.cloneDeep(state)
  let currGraphDataMap = currState.sessionGraphData?currState.sessionGraphData:new Map()  
  let mac = session.target.mac
  let manifest = _.get(session.manifest,mac)
  let fileCount = 1//manifest.recordCnt
  let attributeArray
  let tsIdx
  //Pull new data if no data in store or missing some data
  if(!currGraphDataMap.has(sessionID)){
      let allData = []
      let removed
      //Add Each File
      for(let fileNum=0;fileNum<fileCount;fileNum++){
          let file = await getFile(sessionID,manifest.fileName)
          const results = readString(file);
          file = results.data
          removed = _.pullAt(file, [0,file.length-1])
          console.log("Removed:",removed)
          attributeArray = removed[0]
          let newFile = file.map((i) => (i.map((j) => {
              try {
                  return (
                      isNaN(Number(j))?null:Number(j)
                  )
              } catch (error) {
                  console.error(error)
              }
          })))
          tsIdx = _.indexOf(attributeArray,"ts")
          console.log("Got file ",fileNum)
          allData = allData.concat(newFile)
      }
      let limitedData = await HelperService.limitData(allData)
      let convertedData = await HelperService.convertData(manifest,limitedData,attributeArray)
      let maxMinData = await HelperService.maxMin(convertedData,tsIdx)
      let normalizedData = await HelperService.normalizeData(manifest.toolType,session.settings,convertedData,tsIdx,attributeArray,maxMinData[0],maxMinData[1],manifest.settings)
      currGraphDataMap.set(sessionID, {"totalRecordCount":allData.length,"updatedAt":HelperService.getEpoch(new Date()),"data":allData, "rawData":limitedData, "convertedData": convertedData, "normalData":normalizedData, "maxData":maxMinData[0],"minData":maxMinData[1],"attributes":attributeArray, "fileCount":fileCount}) 
      console.log("ADDED GRAPH DATA TO STORE FOR SESSION")
  }else{
      console.log("Already there")
      let sessionData = currGraphDataMap.get(sessionID)
      tsIdx = _.indexOf(sessionData.attributes,"ts")
      let maxMinData = await HelperService.maxMin(sessionData.convertedData,tsIdx)
      let normalizedData = await HelperService.normalizeData(manifest.toolType,session.settings,sessionData.convertedData,tsIdx,sessionData.attributes,maxMinData[0],maxMinData[1],manifest.settings)
      currGraphDataMap.set(sessionID, {"totalRecordCount":sessionData.totalRecordCount,"updatedAt":HelperService.getEpoch(new Date()),"data":sessionData.data, "rawData":sessionData.rawData, "convertedData": sessionData.convertedData, "normalData":normalizedData, "maxData":maxMinData[0],"minData":maxMinData[1],"attributes":sessionData.attributes, "fileCount":sessionData.fileCount}) 
  }
  _.set(currState,'sessionGraphData',currGraphDataMap)
  _.set(currState,'pullSessions',false)
  if(!_.isEqual(currState,state)) setState(currState)
}

export const clearAlert = async (tool, alert_id) => {
  console.log('clearAlert:',tool, alert_id)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_alertCnt",
        "mac": tool.mac,
        "alert_id": alert_id
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_shared_alertCnt",
        "share_id": tool.share_id,
        "alert_id": alert_id
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const clearAlerts = async (tool) => {
  console.log('clearAlerts:',tool)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_mac_alertCnt",
        "mac": tool.mac,
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "clear_shareID_alertCnt",
        "share_id": tool.share_id
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const deleteAlerts = async (tool, alert_ids) => {
  console.log('deleteAlerts:',tool, alert_ids)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "delete_multi_alerts",
        "mac": tool.mac,
        "alert_ids": alert_ids
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "delete_shared_multi_alerts",
        "share_id": tool.share_id,
        "alert_ids": alert_ids
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const updateAlert = async (tool, alert_id,settings) => {
  console.log('updateAlert:',tool, alert_id,settings)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "update_alert",
        "mac": tool.mac,
        "alert_id": alert_id,
        "settings": settings
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "update_shared_alert",
        "share_id": tool.share_id,
        "alert_id": alert_id,
        "settings": settings
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const addAlert = async (tool,settings,alertMode) => {
  console.log('addAlert:',tool,settings,alertMode)
  let response
  if(_.has(tool,'mac')){
    console.log('has mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/tools/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "add_alert",
        "mac": tool.mac,
        "settings": settings,
        "alertMode":alertMode
      }),
    })
    .then(res => {
      console.log('res:',res)
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      console.log('res:',res)
      return res.json()
    })
    .then(data => {
      console.log('data:',data)
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }else{
    console.log('no mac')
    response = await fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/teams/', {
      method: 'POST',
      headers:{
          'Content-Type': 'application/json',
          'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
          'Authorization': await Aws.token(),
      },
      body: JSON.stringify({ 
        "operation": "add_shared_alert",
        "share_id": tool.share_id,
        "settings": settings,
        "alertMode":alertMode
      }),
    })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error ${res.status}`);
      }
      return res.json()
    })
    .then(data => {
      return data;
    })
    .catch((err) => {
      console.log("Error: ", err)
      return null
    });
  }
  console.log('Response:', response)
  return response
}

export const checkPayMethod = async () => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "check_payment_method"
    }),
  })
  .then(res => {
    console.log('checkPayMethod res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('checkPayMethod Data:',data)
    if (HelperService.in200s(data.status)) {
      let tempData = _.cloneDeep(data)
      let defaultFirst = _.remove(tempData.data,(card)=>card.id == tempData.default_payment_method)
      _.set(tempData,'data',_.concat(defaultFirst,tempData.data))
      return tempData
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const createPayMethod = async (card_update) => {
  console.log('createPayMethod card:',card_update)
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "create_payment_method",
      "type": card_update.type,
      "number": card_update.number,
      "exp_month": card_update.exp_month,
      "exp_year": card_update.exp_year,
      "cvc": card_update.cvc,
    }),
  })
  .then(res => {
    console.log('createPayMethod res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('createPayMethod Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.errorMessage }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const setDefaultPM = async (paymentMethod_id) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "set_default_payment_method",
      "paymentMethod_id": paymentMethod_id
    }),
  })
  .then(res => {
    console.log('setDefaultPM res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('setDefaultPM Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const deletePayMethod = async (paymentMethod_id) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "delete_payment_method",
      "paymentMethod_id": paymentMethod_id
    }),
  })
  .then(res => {
    console.log('deletePayMethod res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('deletePayMethod Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const retrieveInvoices = async () => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "retrieve_invoices"
    }),
  })
  .then(res => {
    console.log('retrieveInvoices res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('retrieveInvoices Data:',data)
    if (HelperService.in200s(data.status)) {
      return data.data
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const createSubscription = async (tierType) => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "create_subscription",
      "tierType": tierType
    }),
  })
  .then(res => {
    console.log('createSubscription res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('createSubscription Data:',data)
    if (HelperService.in200s(data.status)) {
      return true
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};

export const cancelSubscription = async () => {
  return fetch('https://rmtfp39fe7.execute-api.us-east-1.amazonaws.com/stratus_data/user', {
    method: 'POST',
    headers:{
        'Content-Type': 'application/json',
        'x-api-key': 'MfC8Fh7NSB2G1c0d1GT8FRTlZOhYeJ77BX3wVA77',
        'Authorization': await Aws.token(),
    },
    body: JSON.stringify({ 
      "operation": "cancel_subscription"
    }),
  })
  .then(res => {
    console.log('cancelSubscription res:',res)
    if (!res.ok) {
      throw new Error(`HTTP error ${res.status}`);
    }
    return res.json()
  })
  .then(data => {
    console.log('cancelSubscription Data:',data)
    if (HelperService.in200s(data.status)) {
      return data.data
    }else{
      return { errors: data.data.message }
    }
  })
  .catch((err) => {
    console.log("Error: ", err)
    return { errors: err }
  });
};